import { render } from "./PremisesControl.vue?vue&type=template&id=0195e6a2"
import script from "./PremisesControl.vue?vue&type=script&lang=js"
export * from "./PremisesControl.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmytrokulyk/Documents/Development/GreenHub/dsp-f-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__